<template>
  <div class="detail-wrap">
    <div class="detail">
      <!--tabs-->
      <div class="tab-group">
        <el-tabs
          v-model="activeName">
          <el-tab-pane
            v-for="item in editableTabs"
            :key="item.key"
            :label="item.label"
            :name="item.key"></el-tab-pane>
        </el-tabs>
      </div>
      <!--基本信息-->
      <custom-detail v-loading="loading" styleType="singleRow" :detailData="baseInfo">
        <template #detailInfo="{ slotObj }">
          <div class="detail-info">
            <div v-if="!slotObj.isNew" class="info-item">{{ slotObj.value }}</div>
            <div v-else>
              <div v-for="(item, index) in slotObj.value" :key="index" class="list-item">
                <div class="info-name">{{ index + 1 }}. {{ item.resource_name }}</div>
                <div class="info-meta">
                  <span class="info-label">{{ t('alarm.resourceId') }}:</span>
                  <span class="info-id">{{ item.id }}</span>
                  <span class="info-separator">|</span>
                  <span class="info-label">{{ t('alarm.count') }}:</span>
                  <span class="info-count">{{ item.fail_count }}</span>
                  <span class="info-separator">|</span>
                  <span class="info-label">{{ t('alarm.lastDate') }}:</span>
                  <span class="info-last-date">{{ item.last_failed_at }}</span>
                </div>
                <div class="info-item">{{ item.info }}</div>
              </div>
            </div>
          </div>
        </template>
      </custom-detail>
    </div>
  </div>
</template>

<script setup>
import dayjs from 'dayjs'
import CustomDetail from '@/components/CustomDetail/index'
import { getAlarmMessagesDetail } from '@/api/alarmAdmin/alarmMessege'
import { GlobalColor } from '@/utils/globalColor'
import { useI18n } from 'vue-i18n'
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()
const loading = ref(false)
const { t } = useI18n()
const activeName = ref('1')
const editableTabs = [
  {
    key: '1',
    label: t('host.overview')
  }
]
const baseInfo = ref([
  {
    title: t('resources.baseInfo'),
    content: [
      {
        key: t('alarm.message_name'),
        name: 'display_name',
        value: ''
      },
      {
        key: 'ID',
        name: 'id',
        value: ''
      },
      {
        key: t('alarm.alarm_resource'),
        name: 'resource',
        value: ''
      },
      {
        key: t('alarm.alarm_status'),
        name: 'display_status',
        value: ''
      },
      {
        key: t('alarm.level'),
        name: 'display_level',
        value: ''
      },
      {
        key: t('alarm.alarm_type'),
        name: 'display_type',
        value: ''
      },
      {
        key: t('alarm.resource_type'),
        name: 'display_resource_type',
        value: ''
      },
      {
        key: t('table.created_at'),
        name: 'created_at',
        value: ''
      },
      {
        key: t('table.description'),
        name: 'description',
        value: ''
      }
    ]
  },
  {
    title: t('alarm.resource_info'),
    content: [
      {
        key: '',
        name: 'metadata',
        value: ''
      }
    ]
  },
  {
    title: t('alarm.detailInfo'),
    content: [
      {
        type: 'slot',
        isNew: false,
        prop: 'detailInfo',
        value: ''
      }
    ]
  }
])
const getDetailFun = async(id) => {
  const res = await getAlarmMessagesDetail(id)
  const alarmData = res.data.alarm_message
  alarmData.created_at = alarmData.created_at ? dayjs(alarmData.created_at).format('YYYY-MM-DD HH:mm:ss') : ''
  for (const i in baseInfo.value[0].content) {
    const name = baseInfo.value[0].content[i].name
    if (name === 'display_level') {
      baseInfo.value[0].content[i].value = `<i class="fa fa-warning ${alarmData.level}"></i>${alarmData[name]}`
    } else if (name === 'display_status') {
      baseInfo.value[0].content[i].value = `<i class="${alarmData.status === 'unhandled' ? 'failed' : 'success'}" style="margin-right:4px;"></i>${alarmData[name]}`
    } else {
      baseInfo.value[0].content[i].value = alarmData[name]
    }
  }
  const metadataItem = baseInfo.value[1].content[0]
  let html = ``
  if (Object.keys(alarmData.metadata || {}).length > 0) {
    html = `<div style="overflow: auto; max-height: 300px;">{`
    for (const el in alarmData.metadata) {
      html += `<span class="metadata">${el}: <i class="metadata-info">${alarmData.metadata[el]}</i></span>`
    }
    html += `}</div>`
  }
  metadataItem.value = html
  metadataItem.valueTooltipHide = true
  metadataItem.style = { width: '100%' }
  metadataItem.valueStyle = { background: GlobalColor.$grey2, padding: '8px 16px' }
  const slotItem = baseInfo.value[2].content[0]
  if (Object.keys(alarmData.display_resource_messages || {}).length === 0) {
    slotItem.value = alarmData.display_detail_message || t('monitor.no_data')
    slotItem.isNew = false
  } else {
    slotItem.isNew = true
    const resources = alarmData.detail_info?.resources || {}
    const arr2 = []
    Object.entries(resources).forEach(([key, value]) => {
      arr2.push({
        id: key,
        fail_count: value.fail_count,
        last_failed_at: value.last_failed_at
          ? dayjs(value.last_failed_at).format('YYYY-MM-DD HH:mm:ss')
          : '',
        resource_name: value.resource_name,
        info: alarmData.display_resource_messages[key] || t('monitor.no_data')
      })
    })
    slotItem.value = arr2
    const summaryMsg = alarmData.detail_info?.summary?.msg_data
    if (summaryMsg) {
      const arr0 = [
        {
          key: t('alarm.total_resources'),
          name: 'total_resources',
          value: summaryMsg.total_resources
        },
        {
          key: t('alarm.total_events'),
          name: 'total_events',
          value: summaryMsg.total_events
        },
        {
          key: t('alarm.timeWindow'),
          name: 'timeWindow',
          value: `${dayjs(summaryMsg.start).format('YYYY-MM-DD HH:mm:ss')} ~ ${dayjs(summaryMsg.end).format('YYYY-MM-DD HH:mm:ss')}`
        }
      ]
      const idIndex = baseInfo.value[0].content.findIndex((item) => item.name === 'id')
      const insertIndex = idIndex >= 0 ? idIndex + 1 : baseInfo.value[0].content.length
      baseInfo.value[0].content.splice(insertIndex, 0, ...arr0)
    }
  }
}
defineExpose({
  getDetailFun
})
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

::v-deep .detail-info {
  width: 100%;
  margin-top: 16px;
  .info-item {
    width: 100%;
    color: $white;
    background: $black;
    padding: 8px 16px;
    border-radius: 4px;
    max-height: 300px;
    min-height: 38px;
    overflow-y: auto;
    white-space: pre-line;
  }
  .list-item {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
    .info-item {
      border-radius: 0 0 4px 4px;
    }
  }
  .info-name {
    font-weight: 600;
    margin-bottom: 4px;
    color: $grey-9;
  }
  .info-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 6px;
    background: $grey-2;
    border: 1px solid $grey-4;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
  }
  .info-label {
    margin-right: 4px;
    color: $grey-9;
  }
  .info-separator {
    margin: 0 8px;
    color: $grey-7;
  }
}

::v-deep .metadata {
  display: block;
  padding-left: 20px;
  .metadata-info {
    padding-left: 6px;
  }
}
</style>